import React, { useState, useEffect } from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import Field from '../../util/field/Field';
import Select from 'react-select';

const SCHEMA = Yup.object({
    Description: Yup.string().trim().max(40, "Ha excedido el límite de 40 caracteres.").required("El campo 'Descripción' es requerido."),
    Address: Yup.string().trim().max(17, "Ha excedido el límite de 17 caracteres.")
    .test(
        "validate_format", 
        "Formatoinválido", 
        function(value) {
            const SoVersionType = this.parent && this.parent.SoVersion ? this.parent.SoVersion.value : null;
            if (SoVersionType){
                if (SoVersionType !== "Android"){
                    if(!/^([0-9A-Fa-f]{2}([-:])){5}([0-9A-Fa-f]{2})$|^([0-9A-Fa-f]{4}\.){2}([0-9A-Fa-f]{4})$/.test(value))
                        return this.createError({ message: "Formato de MAC inválido ej. AA:BB:CC:DD:EE:FF" });
                }else{
                    if(!/^\d+$/.test(value))
                        return this.createError({ message: "Ingrese solo números" });
                }
            }
            
            return true;
        }),
   
    // .required("El campo 'Dirección Mac' es requerido.").matches(
    //     /^([0-9A-Fa-f]{2}([-:])){5}([0-9A-Fa-f]{2})$|^([0-9A-Fa-f]{4}\.){2}([0-9A-Fa-f]{4})$/,
    //     "Formato de MAC inválido ej. AA:BB:CC:DD:EE:FF"
    //   ),    
    SoVersion: Yup.object().required("El campo 'Versión' es requerido.").nullable(),
    Mactype: Yup.object().required("El campo 'Tipo' es requerido.").nullable(),
});
export const MacForm = ({ ...props }) => { 
    const [macAdress, setMacAdress]  = useState({
        Id:0,
        Description: "",
        Address: "",
        SoVersion: null,
        Mactype: null,
        Active: true,
        IdCaffenio:props.caffenioId

    })

    useEffect(() => {
        if(props.selectedItem){
            let selectedItem = {...props.selectedItem};
            selectedItem.Mactype = props.arrTipoMac.find(x=> x.value == selectedItem.MacType) ;   
            selectedItem.SoVersion = props.arrVersions.find(x=> x.value == selectedItem.SoVersion);
            setMacAdress(selectedItem)
        }      
        
    }, [])

    return (
        <Formik
            enableReinitialize={true}
            initialValues={macAdress}
            validationSchema={SCHEMA}
            onSubmit={(values) => {
                let caffenioUpdated = {...values};
                caffenioUpdated.Mactype = values.Mactype ? values.Mactype.value : null;   
                caffenioUpdated.SoVersion = values.SoVersion ? values.SoVersion.value : null;   
                caffenioUpdated.IdCaffenio = props.caffenioId;
                caffenioUpdated.Id = macAdress.Id;
                caffenioUpdated.Active= true;
            
                props.save(caffenioUpdated)
            }}>
                {({ values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched }) => (
                    <form onSubmit={handleSubmit} id="frmMacs">
                        <div className="columns is-multiline">
                            <div className="column is-12">
                                <Field label="Descripción" isHorizontal
                                    hasError={errors.Description != null}
                                    msgError={errors.Description ? errors.Description : ""}
                                >
                                    <input
                                        className="input"
                                        maxLength="50"
                                        label="Descripción"
                                        name="Description"
                                        value={values.Description}
                                        onChange={(e) => handleChange(e)}

                                    />
                                </Field>
                            </div>
                            <div className="column is-12">
                                <Field label="Dirección Mac" isHorizontal
                                    hasError={errors.Address != null}
                                    msgError={errors.Address ? errors.Address : ""}
                                >
                                    <input
                                        className="input"
                                        maxLength="50"
                                        label="Dirección Mac"
                                        name="Address"
                                        value={values.Address}
                                        onChange={(e) => handleChange(e)}

                                    />
                                </Field>
                            </div>
                            
                            <div className="column is-6">
                                <Field label="Versión SO" 
                                    hasError={errors.SoVersion != null}
                                    msgError={errors.SoVersion ? errors.SoVersion : ""}>
                                    {
                                        <div className="column is-12">
                                            <Select
                                            placeholder={"Seleccionar..."}
                                            name={"SoVersion"}
                                            value={values.SoVersion}
                                            onChange={(val) => {setFieldValue('SoVersion', val)}}
                                            noOptionsMessage={() => "No hay opciones"}
                                            options={props.arrVersions}
                                            isClearable />
                                        </div>
                                    }
                                </Field>
                            </div>

                            <div className="column is-6">
                                <Field label="Tipo Mac" 
                                    hasError={errors.Mactype}
                                    msgError={errors.Mactype ? errors.Mactype : ""}>
                                    {
                                        <div className="column is-12">
                                            <Select
                                            placeholder={"Seleccionar..."}
                                            name={"Mactype"}
                                            value={values.Mactype}
                                            onChange={(val) => {setFieldValue('Mactype', val)}}
                                            noOptionsMessage={() => "No hay opciones"}
                                            options={props.arrTipoMac}
                                            isClearable />
                                        </div>
                                    }
                                </Field>
                            </div>
                        </div>

                        <br />

                        <div className="has-text-left buttons-modal" id="stepActions">

                        </div>
                        <div className="has-text-right buttons-modal" id="stepActions">
                            <div className="pull-right">
                                <button id="btnSaveMacAddress" type="submit" className="button is-success"  >Guardar</button>
                            </div>
                        </div>
                    </form>
            )}

        </Formik>
    );
                


}

export default MacForm;